import { gql } from '@apollo/client'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { RefreshWorkOrderInsufficientItemsArgs, WorkOrder } from '@ztechapps/common.contract'
import { workOrderInsufficientItemsFragment } from './graphql'

export const refreshWorkOrderInsufficientItemsQuery = gql`
  mutation refreshWorkOrderInsufficientItems($input: RefreshWorkOrderInsufficientItemsArgs!) {
    refreshWorkOrderInsufficientItems(input: $input) {
      _id
      insufficientItems {
        ...workOrderInsufficientItemsFragment
      }
      subAssemblyCost
      totalManufactureCost
    }
  }
  ${workOrderInsufficientItemsFragment}
`

export const useRefreshWorkOrderInsufficientItems = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, RefreshWorkOrderInsufficientItemsArgs> => {
  query = query ?? refreshWorkOrderInsufficientItemsQuery

  return useActionMutation({
    query,
    ...props,
  })
}
